import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';

const EntityContext = createContext(null);

export function EntityProvider({ children }) {
  const [entities, setEntities]   = useState([]);
  const [currentEntityId, setCurrentEntityId] = useState(
    () => localStorage.getItem('crm_entity_id') || 'auto'
  );
  const [userEntityId, setUserEntityId] = useState(null);

  // Load entities and own entity on mount
  useEffect(() => {
    // Fetch user's own entity from /auth/me
    API.get('/auth/me')
      .then(r => {
        const eid = r.data?.entity_id;
        setUserEntityId(eid || null);
        // If no preference stored, default to own entity (not 'all')
        if (!localStorage.getItem('crm_entity_id') || localStorage.getItem('crm_entity_id') === 'auto') {
          const defaultEid = eid ? String(eid) : '1';
          setCurrentEntityId(defaultEid);
          localStorage.setItem('crm_entity_id', defaultEid);
        }
      })
      .catch(() => {});

    API.get('/entities')
      .then(r => setEntities(r.data))
      .catch(() => {});
  }, []);

  const setEntity = (id) => {
    setCurrentEntityId(String(id));
    localStorage.setItem('crm_entity_id', String(id));
  };

  const currentEntity = currentEntityId === 'all'
    ? null
    : entities.find(e => String(e.id) === String(currentEntityId));

  // entityParam: undefined means "own entity" (backend enforces); 'all' is admin-only
  const entityParam = currentEntityId === 'all' ? 'all' : currentEntityId;

  return (
    <EntityContext.Provider value={{
      entities, currentEntityId, currentEntity,
      userEntityId, setEntity, entityParam
    }}>
      {children}
    </EntityContext.Provider>
  );
}

export const useEntity = () => useContext(EntityContext);
